import React from 'react';
import { branding } from './siteConfig.js';

function DemoBanner() {
  if (!branding.showDemoBanner) return null;

  return (
    <div className="demo-banner" role="status">
      <strong>Demo mode</strong>
      <span>
        You are viewing <em>{branding.communityName}</em> with fictional data. Changes are not saved
        to production.
      </span>
    </div>
  );
}

export default DemoBanner;